"use client"

import { Button, Center, Stack, Text, Title } from "@mantine/core"
import * as Sentry from "@sentry/nextjs"
import { useEffect } from "react"

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <Center h="90vh">
      <Stack align="center" gap="md">
        <Title>Something went wrong</Title>
        <Text c="dimmed">{error.message}</Text>
        <Button onClick={() => reset()}>Try again</Button>
      </Stack>
    </Center>
  )
}
